import React from "react"
import { useTranslation } from "react-i18next"
import { CleanHtml } from "swiipe.portal.shared"
import { IReleaseNote } from "../../type/releaseNotes/releaseNote"
import "./ReleaseNoteDisplay.scss"

interface IReleaseNoteDisplay {
    releaseNote: IReleaseNote
}

const ReleaseNoteDisplay = ({ releaseNote }: IReleaseNoteDisplay) => {
    const { t } = useTranslation()
    return (
        <div id="release-note-display">
            <p className="version">{releaseNote.version}</p>
            <p className="date">{releaseNote.createdDate}</p>
            <CleanHtml element="div" html={releaseNote.htmlBody} />
            {releaseNote.internalHtmlBody && (
                <div>
                    <i>Internal:</i>
                    <CleanHtml element="div" html={releaseNote.internalHtmlBody} />
                </div>
            )}
        </div>
    )
}

export default ReleaseNoteDisplay
